import { render, staticRenderFns } from "./AmazonMarketplaceWidget.vue?vue&type=template&id=0edc9a96&scoped=true"
import script from "./AmazonMarketplaceWidget.vue?vue&type=script&lang=ts"
export * from "./AmazonMarketplaceWidget.vue?vue&type=script&lang=ts"
import style0 from "./AmazonMarketplaceWidget.vue?vue&type=style&index=0&id=0edc9a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc9a96",
  null
  
)

export default component.exports